import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Grid, Paper } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { userServices } from "../../../../service/UserService";
import AssociationsOffreList from "./AssociationsOffreList";
import CorporateFareOutlinedIcon from '@mui/icons-material/CorporateFareOutlined';
import Diversity2OutlinedIcon from "@mui/icons-material/Diversity2Outlined";
import AgexOffreList from "./AgexOffreList";
import { exportToExcelJS } from "../../../../Helpers/ExcelJsHelper";


export const handleExportExcel = (reponses,titre) => {
    let columns = [
      { headerName: "AMI", field: "libelle_type", width: 150 },
      { headerName: "AMI zone", field: "zone", width: 150 },
      { headerName: "AMI Region", field: "region", width: 150 },
      { headerName: "Date de soumission", field: "date_postule", width: 150 },
     /*  { headerName: "ID association", field: "id_ext_association", width: 150 },
      { headerName: "ID Reponse", field: "id_sqc_reponse", width: 150 }, */
      { headerName: "Nom de l'agence / association", field: "nom", width: 150 },
      { headerName: "Statut", field: "status_asso", width: 150 },
      { headerName: "Numero NIF", field: "num_nif", width: 150 },
      { headerName: "Numero STAT", field: "num_stat", width: 150 },
      { headerName: "Annee de création de l'agence / association", field: "annee_creation", width: 150 },
      { headerName: "Adresse de l'agence / association", field: "adresse", width: 150 },
      { headerName: "Region de couverture", field: "region_couv", width: 150 },
      { headerName: "Nom du gerant", field: "gerant_noms", width: 150 },
      { headerName: "Contact du gerant", field: "gerant_telephone", width: 150 },
      { headerName: "Email du gerant", field: "gerant_email", width: 150 },
      { headerName: "Question", field: "question", width: 150 },
      { headerName: "Reponse", field: "reponse", width: 100 },
      { headerName: "commentaire", field: "commentaire", width: 125 },
      { headerName: "pj", field: "pj", width: 75 },
      { headerName: "lien de la pj", field: "pj_link", width: 250 },
    ];
    exportToExcelJS(reponses, columns, titre || "Résumé des réponses par AMI");
  };

export default function RecrutementPage() {
  const [userInfo, setUserInfo] = React.useState({});
  const location = useLocation();
  const [loadUserInfo, setLoadUserInfo] = React.useState(false);
  const [tabsChargee, setTabChargee] = React.useState([]);
  const navigate = useNavigate();
  const query = new URLSearchParams(location.search);
  const tab_value = query.get("tab") || "0";

  const createContenus = (userInfo) => {
    const tabs = [
      /* {
        title: "Offres consultant",
        content: <ConsultantOffreList />,
        icon: <PermIdentityOutlinedIcon />,
        idx: "1",
      }, */
      {
        title: "Offres volontariat",
        content: <AssociationsOffreList />,
        icon: <Diversity2OutlinedIcon />,
        idx: "2",
      },
      {
        title: "Offres AGEX",
        content: <AgexOffreList />,
        icon: <CorporateFareOutlinedIcon />,
        idx: "3",
      },
    ];

    return tabs;
  };

  const handleFetchUserInfo = (tabs = true) => {
    const curr_tab = "0";
    setLoadUserInfo(true);
    userServices
      .getMyProfile()
      .then((res) => {
        if (res && res.success) {
          setUserInfo(res.data);
          setTabChargee((prev) => [...prev, curr_tab]);
        }
      })
      .finally(() => {
        setLoadUserInfo(false);
      });
  };

  React.useEffect(() => {
    handleFetchUserInfo();
  }, []);

  const handleChange = (event, newValue) => {
    navigate(`?tab=${newValue}`);
  };

  const [contenus, setContenus] = React.useState([]);

  React.useEffect(() => {
    setContenus(createContenus(userInfo));
  }, [userInfo]);

  return (
    <Grid container justifyContent="center" spacing={2} sx={{ mb: 2 }}>
      <Grid item xs={12} md={11} lg={10}>
        <Paper elevation={1} sx={{ minHeight: "30vh" }}>
          <TabContext value={tab_value}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={handleChange}
                aria-label="lab API tabs example"
                variant="scrollable"
                scrollButtons="auto"
              >
                {contenus.map((item, index) => (
                  <Tab
                    key={index}
                    label={item.title}
                    icon={item.icon}
                    iconPosition="start"
                    value={index.toString()}
                  />
                ))}
              </TabList>
            </Box>
            <Grid item>
              {contenus.map((item, index) => (
                <TabPanel key={index} value={index.toString()}>
                  {item.content}
                </TabPanel>
              ))}
            </Grid>
          </TabContext>
        </Paper>
      </Grid>
    </Grid>
  );
}
